<template>
	<div class="big" style="font-size: 0;">
		<div v-if="type == '1'">
		<h2 style="font-size: 0.36rem;line-height: 0.5rem;color: #333333;width: 96%;margin: 0 auto;margin-bottom: 0.24rem;padding-top: 0.24rem;">{{formList.title}}</h2>
		<p style="width: 96%;margin: 0 auto;margin-bottom: 0.32rem;">
			<span style="font-size: 0.28rem;color: #999999;margin-right: 0.38rem;">{{ formList.sender }}</span>
			<span style="color: #999999;font-size: 0.28rem;">{{ formList.sendTimeStr }}</span>
		</p>
		<div class="div_html" v-html="formList.content" style="font-size:0.28rem;"></div>
		</div>
		<div  v-if="type == '2'" style="text-align: center; position: fixed;left: 50%;top: 50%;transform: translate(-50%,-50%);font-size: 0.5rem;color: rgb(153, 153, 153);">暂无内容</div>
		
	</div>
</template>
<script>
	import request from '@/utils/request'
	export default {
		components: {

		},
		data() {
			return {
				formList: {},
				userId: '',
				msgId: '',
				type:''
			}
		},
		mounted() {

			this.initData();
		},
		created() {
			this.userId = this.getUrlParam('userId');
			this.msgId = this.getUrlParam('msgId');
		},
		methods: {
			getUrlParam(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return unescape(r[2]);
				return null;
			},
			initData() {
				let _this = this;
				let url = Global.env + Global.apiCore.messageDetails + "/" + this.userId + "/" + this.msgId;
				// let url = Global.env + Global.apiCore.messageDetails + "/" + '611142695208886272' + "/" + '644900177588518912';
				return new Promise((resolve, reject) => {
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
							this.type = '1';
							_this.formList = response.data;
							return resolve()
						}else if(response.resultCode === "1002"){
							this.type = '2';
						}
					}).catch(error => {
						return reject(error);
						this.type = '2';
					})
				})
			}
		}
	}
</script>

<style>
	.big {
		width: 100%;
	}

	.div_html {
		margin: 0 auto;
		width: 96%;
	}

	.div_html p {
		line-height: 0.4rem;
		color: #666666;
		font-size: 0.28rem !important;
	}

	.div_html img {
		width: 100%;
		margin: 0 auto;
	}
</style>
